import React, { createContext, useState, useEffect, useContext, useRef, useCallback } from "react";
import { getSymbol, subscribeSocketApi, unsubscribeSocketApi } from "../api/request/dashboard/dashboard";
import { getCookies } from "../services/Cookies";
import { useDispatch, useSelector } from "react-redux"
import { addEmail, deleteEmail, setUsers, setDepartment } from "../store/Slices/emailsSlice";
import { setNews } from '../store/Slices/newsSlice'
import { setAccountSummary, setAccountId } from '../store/Slices/accountSummary'
import { saveAlertData, updateAlertData, deleteAlertData } from '../store/Slices/alertSlice';
import { addOrdersData, deleteOrdersData, deletePositionsData, addPositionsData, updateOrdersData, updatePositionData, deleteSLTPOrder, editSLTPOrder, addSLTPOrder, setAccountHistoryData } from '../store/Slices/orderPositionSlice';
import { setGroupData, setUnitData } from '../store/Slices/symbolGroupUnitSlice';
import { setSymbolsData, addNewSymbol, updateSymbol, deleteSymbol } from '../store/Slices/watchList'
import { throttle } from "lodash";
import { GetAccount } from "../store/thunks/accountSummary";
import { publishNewTick } from "../components/charts/RealtimeTrdingChart";
import { setAccountTree, addNewClient, updateClient, deleteClient, addNewAccount, updateAccount, deleteAccount } from '../store/Slices/accountTree'
import toast from "react-hot-toast";
import { fetchSymbols } from '../store/thunks/watchlist'
import { fetchAllPositions } from "../store/thunks/orders";
import { fetchAllSymbolParams } from "../store/thunks/symbolGroup";
import { deletePLValue } from "../components/footer/AccountFooter";
import { updateProfitLoss } from "../store/Slices/profitLossSlice";
import useWebSocket from "react-use-websocket";
const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const token = getCookies("token");
  const [symbolPrices, setSymbolPrices] = useState({});
  const [socketUrl, setSocketUrl] = useState(`${process.env.REACT_APP_BASE_URL_WS}/ws?Authorization=${token}`)
  const { globalSymbolID } = useSelector(state => state?.globalSymbol)
  const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
  const { symbols } = useSelector(state => state?.watchlist)
  const dispatch = useDispatch();
  const { accountId } = useSelector(state => state.accountSummary)
  const clientId = getCookies("clientId");
  const dataRef = useRef({});

  const { lastJsonMessage } = useWebSocket(socketUrl, {
    onOpen: () => subscribeSocket(),
    onClose: () => console.log("❌ WebSocket Disconnected"),
    shouldReconnect: () => true, // Auto-reconnect on failure
  })

  // useEffect(() => {
  //   const token = getCookies("token");
  //   const socket = new WebSocket(`${process.env.REACT_APP_BASE_URL_WS}/ws?Authorization=${token}`);
  //   fetchAllSymbols().then(() => {
  //     socket.onmessage = (data) => {
  //       try {
  //         const data1 = JSON.parse(data?.data);
  //         if (data1?.eventType === 0) {
  //           data1?.value?.forEach((update) => {
  //             publishNewTick({ ...update, ts: Date.now() }, "", update.symbolID)
  //             dataRef.current[update.symbolID] = {
  //               ...dataRef.current[update.symbolID],
  //               ...update,
  //               ...(dataRef.current?.[update.symbolID]?.bid > update?.bid ? { bidColor: 'down' } : { bidColor: 'up' }),
  //               ...(dataRef.current?.[update.symbolID]?.ask > update?.ask ? { askColor: 'down' } : { askColor: 'up' }),
  //               ask: update.ask + (allSymbolParams?.[update.symbolID].spreadAskBalance * (1 / Math.pow(10, dataRef?.current?.[update.symbolID]?.digits))),
  //               bid: update.bid + (allSymbolParams?.[update.symbolID].spreadBidBalance * (1 / Math.pow(10, dataRef?.current?.[update.symbolID]?.digits))),
  //             }
  //           })
  //           setSymbolPrices({ ...dataRef.current })
  //         } else if (data1?.eventType === 1) {
  //           addPosition(data1?.value)
  //         } else if (data1?.eventType === 2) {
  //           deletePoisitions(data1?.value)
  //         } else if (data1?.eventType === 3) {
  //           updatePosition(data1?.value)
  //         } else if (data1?.eventType === 4) {
  //           addSLTPOrderData(data1?.value)
  //         } else if (data1?.eventType === 5) {
  //           editSLTPOrderData(data1?.value)
  //         } else if (data1?.eventType === 6) {
  //           deleteSLTPOrderData(data1?.value)
  //         } else if (data1?.eventType === 7) {
  //           marketOrder(data1?.value)
  //         } else if (data1?.eventType === 8) {
  //           deleteMarketOrder(data1?.value)
  //         } else if (data1?.eventType === 11) {
  //           addPendingOrder(data1?.value)
  //         } else if (data1?.eventType === 12) {
  //           updatePendingOrder(data1?.value)
  //         } else if (data1?.eventType === 13) {
  //           deletePendingOrder(data1?.value)
  //         } else if (data1?.eventType === 14) {
  //           updateAccountSummary(data1?.value)
  //         } else if (data1?.eventType === 15) {
  //           addMail(data1?.value)
  //         } else if (data1?.eventType === 16) {
  //           deleteMail(data1?.value)
  //         } else if (data1?.eventType === 17) {
  //           saveAlert(data1?.value)
  //         } else if (data1?.eventType === 18) {
  //           editAlert(data1?.value)
  //         } else if (data1?.eventType === 19) {
  //           deleteAlert(data1?.value)
  //         } else if (data1?.eventType === 26) {
  //           addAccountData(data1?.value)
  //         } else if (data1?.eventType === 27) {
  //           updateAccountData(data1?.value)
  //         } else if (data1?.eventType === 28) {
  //           deleteAccountData(data1?.value)
  //         } else if (data1?.eventType === 29) {
  //           addNewSymbolData(data1?.value)
  //         } else if (data1?.eventType === 30) {
  //           updateSymbolData(data1?.value)
  //         } else if (data1?.eventType === 31) {
  //           deleteSymbolData(data1?.value)
  //         } else if (data1?.eventType === 32) {
  //           addClientData(data1?.value)
  //         } else if (data1?.eventType === 33) {
  //           editClientData(data1?.value)
  //         } else if (data1?.eventType === 34) {
  //           deleteClientData(data1?.value)
  //         } else if (data1?.eventType === 35) {
  //           toast.error("Your account has been liquidated")
  //         } else if (data1?.eventType === 37) {
  //           dispatch(fetchAllSymbolParams())
  //         } else if (data1?.eventType === 40) {
  //           setAccountHistory(data1?.value)
  //         }
  //       } catch (err) { console.log(err.message) }
  //     };
  //   }).catch(err => { });
  //   socket.onopen = () => {
  //     subscribeSocket(accountId)
  //   }
  //   return () => socket.close();
  // }, [allSymbolParams]);

  useEffect(() => {
    if (lastJsonMessage?.eventType !== undefined) {
      const { value } = lastJsonMessage;
      switch (lastJsonMessage.eventType) {
        case 0: if (dataRef?.current) {
          value?.forEach((update) => {
            publishNewTick({ ...update, ts: Date.now() }, "", update.symbolID)
            dataRef.current[update.symbolID] = {
              ...dataRef.current[update.symbolID],
              ...update,
              ...(dataRef.current?.[update.symbolID]?.bid > update?.bid ? { bidColor: 'down' } : { bidColor: 'up' }),
              ...(dataRef.current?.[update.symbolID]?.ask > update?.ask ? { askColor: 'down' } : { askColor: 'up' }),
              ask: update.ask + (allSymbolParams?.[update.symbolID]?.spreadAskBalance * (1 / Math.pow(10, dataRef?.current?.[update.symbolID]?.digits))),
              bid: update.bid + (allSymbolParams?.[update.symbolID]?.spreadBidBalance * (1 / Math.pow(10, dataRef?.current?.[update.symbolID]?.digits))),
            }
          })
          setSymbolPrices({ ...dataRef.current })
        };
          break;
        case 1:
          addPosition(value);
          break;
        case 2:
          deletePoisitions(value);
          break;
        case 3:
          updatePosition(value);
          break;
        case 4:
          addSLTPOrderData(value);
          break;
        case 5:
          editSLTPOrderData(value);
          break;
        case 6:
          deleteSLTPOrderData(value);
          break;
        case 7:
          marketOrder(value);
          break;
        case 8:
          deleteMarketOrder(value);
          break;
        case 11:
          addPendingOrder(value);
          break;
        case 12:
          updatePendingOrder(value);
          break;
        case 13:
          deletePendingOrder(value);
          break;
        case 14:
          updateAccountSummary(value);
          break;
        case 15:
          addMail(value);
          break;
        case 16:
          deleteMail(value);
          break;
        case 17:
          saveAlert(value);
          break;
        case 18:
          editAlert(value);
          break;
        case 19:
          deleteAlert(value);
          break;
        case 26:
          addAccountData(value);
          break;
        case 27:
          updateAccountData(value);
          break;
        case 28:
          deleteAccountData(value);
          break;
        case 29:
          addNewSymbolData(value);
          break;
        case 30:
          updateSymbolData(value);
          break;
        case 31:
          deleteSymbolData(value);
          break;
        case 32:
          addClientData(value);
          break;
        case 33:
          editClientData(value);
          break;
        case 34:
          deleteClientData(value);
          break;
        case 35:
          toast.error("Your account has been liquidated");
          break;
        case 37:
          dispatch(fetchAllSymbolParams());
          break;
        case 40:
          setAccountHistory(value);
          break;

        default:
          console.warn(``);
      }
    }
  }, [lastJsonMessage])


  const subscribeSocket = async (accountId) => {
    try {
      // await unsubscribeSocketApi()
      const { data } = await subscribeSocketApi(accountId);
    } catch (err) {
      console.log("error from subscribe", err.message)
    }
  }

  useEffect(() => {
    if (accountId) {
      subscribeSocket(accountId)
    }
  }, [accountId])

  useEffect(() => {
    const token = getCookies("token");
    setSocketUrl(`${process.env.REACT_APP_BASE_URL_WS}/ws?Authorization=${token}`)
  }, [token])

  useEffect(() => {
    setSymbolPrices({ ...symbols })
    dataRef.current = { ...symbols }
  }, [symbols])


  const addPosition = async (data) => {
    dispatch(addPositionsData(data))
  }

  const updatePosition = async (data) => {
    console.log("data")
    dispatch(updatePositionData(data))
  }

  const deletePoisitions = async (data) => {
    deletePLValue(data)
    dispatch(updateProfitLoss());
    dispatch(deletePositionsData(data))
  }

  const addPendingOrder = async (data) => {
    dispatch(addOrdersData(data))
  }

  const updatePendingOrder = async (data) => {
    dispatch(updateOrdersData(data))
  }

  const deletePendingOrder = async (data) => {
    dispatch(deleteOrdersData(data))
  }

  const updateAccountSummary = async (data) => {
    dispatch(setAccountSummary(data))
  }
  const deleteSLTPOrderData = async (data) => {
    deletePLValue(data)
    dispatch(updateProfitLoss());
    dispatch(deleteSLTPOrder(data))
  }
  const editSLTPOrderData = async (data) => {
    dispatch(editSLTPOrder(data))
  }
  const addSLTPOrderData = async (data) => {
    dispatch(addSLTPOrder(data))
  }
  const deleteAlert = async (data) => {
    dispatch(deleteAlertData(data))
  }
  const editAlert = async (data) => {
    dispatch(updateAlertData(data))
  }
  const saveAlert = async (data) => {
    dispatch(saveAlertData(data))
  }
  const addMail = async (data) => {
    dispatch(addEmail(data))
  }
  const deleteMail = async (data) => {
    dispatch(deleteEmail(data))
  }
  const addClientData = async (data) => {
    dispatch(addNewClient(data))
  }
  const editClientData = async (data) => {
    dispatch(updateClient(data))
  }
  const deleteClientData = async (data) => {
    dispatch(deleteClient(data))
  }
  const addNewSymbolData = async (data) => {
    // dispatch(addNewSymbol(data))
    fetchSymbols()
  }
  const updateSymbolData = async (data) => {
    // dispatch(updateSymbol(data))
    fetchSymbols()
  }
  const deleteSymbolData = async (data) => {
    // dispatch(deleteSymbol(data))
    fetchSymbols()
  }
  const setAccountHistory = async (data) => {
    dispatch(setAccountHistoryData(data))
  }
  const addAccountData = async (data) => {
    // dispatch(addNewAccount(data))
    GetAccount()
  }
  const updateAccountData = async (data) => {
    dispatch(updateAccount(data))
  }
  const deleteAccountData = async (data) => {
    dispatch(deleteAccount(data))
  }
  const marketOrder = async (data) => {
    fetchAllPositions()
  }
  const deleteMarketOrder = async (data) => {
    fetchAllPositions()
  }

  return (
    <WebSocketContext.Provider value={symbolPrices}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useSymbolPrices = () => useContext(WebSocketContext);
